import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import close from "../../assets/icons/close.svg";

const AddFeeHeadModal = ({
  isOpen,
  onClose,
  onSubmit,setNewFeeHead,newFeeHead,
  title="Add Fee Head",
  btnTitle="Add Head",
  placeholder="Enter fee head"
}) => {
 
  const inputRef = useRef(null);

  // Focus input when modal opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleAdd = () => {
    if (newFeeHead.trim()) {
      onSubmit(newFeeHead.trim());
      setNewFeeHead("");
    }
  };

  return createPortal(
    <div
      className="modal-overlay"
      style={{
        zIndex: 9999999,
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <div
        className="modal-content"
        style={{
          position: "relative",
          width: "40%",
          backgroundColor: "white",
          zIndex: 10000000,
          padding: "20px"
        }}
      >
        {/* Header */}
        <div className="modal-header-content d-flex justify-content-between align-items-center mb-3">
          <h4 className="text-primary m-0">{title}</h4>
          <button className="close-btn" onClick={onClose}>
            <img src={close} alt="close" />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body" style={{ overflowY: "unset" }}>
          <input
            type="text"
            value={newFeeHead}
            ref={inputRef}
            onChange={(e) => setNewFeeHead(e.target.value)}
            className="form-control"
            placeholder={placeholder}
            required
          />
          {/* Footer Buttons */}
          <div className="d-flex justify-content-end gap-2 mt-4">
            <button className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button className="add-btn" onClick={handleAdd}>
             {btnTitle}
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddFeeHeadModal;
